module.exports = __webpack_public_path__ + "static/media/arrow-outlined-left.c23ce03b.svg";